/**
 * Created by fers on 05.02.16.
 */

import PureRenderMixin from 'react-addons-pure-render-mixin';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import LoadingButton from './LoadingButton.react';
import React from 'react';
import PropTypes from 'prop-types';
import EditorSaver from './EditorSaver';
import {displayError} from '../app/errorDisplayer';
import EventTracker from '../app/EventTracker';
import * as BrowserPermission from "../BrowserPermission";
import ConfirmDialog from './ConfirmDialog.react';
import LastOrganisationId from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'deleteConfirmation.title', 'defaultMessage': 'Do you really want to delete?'},
    cancel: {id: 'cancel', 'defaultMessage': 'Cancel'},
    delete: {id: 'delete', 'defaultMessage': 'Delete'},
    title_disconnect: {id: 'disconnectConfirmation.title', 'defaultMessage': 'Do you really want to disconnect application?'},
    disconnect: {id: 'disconnect', 'defaultMessage': 'Disconnect'}
});

interface DeleteButtonProps {
 afterDelete?: (...args: unknown[]) => unknown;
 asLink?: boolean;
 beforeDelete?: (...args: unknown[]) => unknown;
 className?: string;
 confirmDialogConfig?: object;
 data: object;
 deleteFatQuery?: object;
 deleteMutation?: object;
 disconnect?: boolean;
 intl: IntlShape;
 metadata: object;
 onSuccess?: (...args: unknown[]) => unknown;
 organisationId?: string;
 parent?: object;
 redirectToParent?: boolean;
 style?: object;
 title?: any;
 types?: object;
 urlMapping: object;
}

class DeleteButton extends React.Component<DeleteButtonProps> {
    static propTypes = {
        afterDelete: PropTypes.func,
        asLink: PropTypes.bool,
        beforeDelete: PropTypes.func,
        className: PropTypes.string,
        confirmDialogConfig: PropTypes.object,
        data: PropTypes.object.isRequired,
        deleteFatQuery: PropTypes.object,
        deleteMutation: PropTypes.object,
        disconnect: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        metadata: PropTypes.object.isRequired,
        onSuccess: PropTypes.func,
        organisationId: PropTypes.string,
        parent: PropTypes.object,
        redirectToParent: PropTypes.bool,
        style: PropTypes.object,
        title: PropTypes.any,
        types: PropTypes.object,
        urlMapping: PropTypes.object.isRequired,
    };

    static defaultProps = {
        redirectToParent: true,
        organisationId: LastOrganisationId.get()
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    onClick = (event) => {
        let promise = Promise.resolve(true);

        if (this.props.beforeDelete) {
            promise = Promise.resolve(this.props.beforeDelete());
        }

        return promise.then((shouldDelete) => {
            if (!shouldDelete) {
                return;
            }

            new Promise((resolve, reject) => {

                let confirmDialogConfig  = {
                    message: this.props.intl.formatMessage(messages.title),
                    confirm: this.props.intl.formatMessage(messages.delete),
                    confirmStyle: 'btn-danger'
                };

                if (this.props.confirmDialogConfig) {
                    confirmDialogConfig = {...confirmDialogConfig, ...this.props.confirmDialogConfig};
                }

                return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
                    return this.onClickConfirmation().then(() => {
                        return resolve();
                    });
                }).catch(() => {
                    resolve();
                });
            });
        });
    };

    onClickConfirmation = () => {
        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: this.props.metadata.entity() + '-' + ('delete'),
            type: 'application'
        });

        let saver = new EditorSaver(this.props.metadata, this.props.deleteMutation, this.props.deleteFatQuery, null, EditorSaver.DELETE);
        return saver.save(this.props.data).then((save) => {
            if (this.props.onSuccess) {
                return this.props.onSuccess();
            }

            if (this.props.afterDelete) {
                return this.props.afterDelete();
            }

            if (this.props.redirectToParent && this.props.types) {
                let { urlMapping, metadata, data } = this.props;

                let parentField = metadata.getParentField(data);
                if (parentField) {
                    let parent;

                    if (this.props.parent) {
                        parent = this.props.parent;
                    } else {
                        parent = data[parentField.key];

                        if (!parent) {
                            parent = data[parentField.key + "_id"];
                        }
                    }

                    if (parent) {
                        let path = urlMapping.getUrl(this.props.types[parentField.to().entity()], "view", parent);
                        this.context.router.push(path);

                        return;
                    }
                }
            }

            if (this.props.metadata) {
                if (this.props.parent) {
                    let path = this.props.urlMapping.getUrl(this.props.metadata, "list", this.props.parent);
                    this.context.router.push(path);
                } else {
                    let path = this.props.urlMapping.getUrl(this.props.metadata, "list", this.props.data);
                    this.context.router.push(path);
                }
            }
        }).catch((e) => {
            displayError(e);
        });
    };

    render() {
        let buttonTitle = this.props.title || (<FormattedMessage defaultMessage="Delete" id="delete"/>);

        if (this.props.metadata.canUserDelete(this.props.data) && this.props.metadata.canDelete(BrowserPermission.getPermissionObject(), this.props.data, this.props.organisationId)) {
            if (this.props.asLink) {
                return (
                    <a className={this.props.className} href="#" onClick={(e) => this.onClick(e)} style={this.props.style}>
                        <i aria-hidden="true" className="fa fa-fw fa-close"></i>{" "}
                        {buttonTitle}
                    </a>
                );
            }

            return (
                <LoadingButton className={"btn btn-default " + (this.props.className ? this.props.className : "")} onClick={this.onClick} style={this.props.style}>
                    <i aria-hidden="true" className="fa fa-close"></i>{" "}
                    {buttonTitle}
                </LoadingButton>
            );
        }

        return null;
    }
}

export default injectIntl(DeleteButton);
